export default "/images/cloud-off.svg?a686de179fa512ec708a6427e1e8b880";